// ✅ No structural changes required to SkillEditor.js
// 🧹 But update comments and variable labels for clarity (rename skill to skill)

import React, { useState, useRef } from 'react';

const SkillEditor = ({ skills, setSkills, fixedTier }) => {
    const [form, setForm] = useState({
        name: '',
        notes: '',
        isDefaultUnlocked: false,
        isPassive: false
    });

    const nameInputRef = useRef(null);
    const notesInputRef = useRef(null);
    const containerRef = useRef();

    const addSkill = () => {
        if (!form.name.trim()) return;
        const updated = { ...skills };
        updated[fixedTier] = [...(updated[fixedTier] || []), {
            name: form.name.trim(),
            notes: form.notes?.trim() || undefined,
            isDefaultUnlocked: form.isDefaultUnlocked,
            isPassive: form.isPassive
        }];
        setSkills(updated);
        setForm({ name: '', notes: '', isDefaultUnlocked: false, isPassive: false });
        nameInputRef.current?.focus();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            addSkill();
        } else if (e.key === 'Tab' && e.target.name === 'name') {
            e.preventDefault();
            notesInputRef.current?.focus();
        } else if (e.key === ' ' && e.target.dataset.toggle) {
            e.preventDefault();
            const field = e.target.dataset.toggle;
            setForm((prev) => ({ ...prev, [field]: !prev[field] }));
        }
    };

    const handleBlur = (e) => {
        if (!e.relatedTarget || !containerRef.current.contains(e.relatedTarget)) {
            if (form.name.trim()) addSkill();
        }
    };

    return (
        <div className="skill-card new-skill-card animate-fade-in" ref={containerRef}>
            <div
                className={`toggle ${form.isDefaultUnlocked ? 'active' : ''}`}
                tabIndex="0"
                role="button"
                data-toggle="isDefaultUnlocked"
                onClick={() => setForm({ ...form, isDefaultUnlocked: !form.isDefaultUnlocked })}
                onKeyDown={handleKeyDown}
            >
                Default
            </div>
            <div
                className={`toggle ${form.isPassive ? 'active' : ''}`}
                tabIndex="0"
                role="button"
                data-toggle="isPassive"
                onClick={() => setForm({ ...form, isPassive: !form.isPassive })}
                onKeyDown={handleKeyDown}
            >
                Passive
            </div>
            <input
                name="name"
                ref={nameInputRef}
                type="text"
                className="styled-input skill-name-header"
                placeholder="Enter skill name..."
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
            />
            <input
                name="notes"
                ref={notesInputRef}
                type="text"
                className="styled-input"
                placeholder="Notes (optional)"
                value={form.notes}
                onChange={(e) => setForm({ ...form, notes: e.target.value })}
                onKeyDown={handleKeyDown}
            />
        </div>
    );
};

export default SkillEditor;
